(function () {
  const headerMenu = document.querySelector(".header__inline-menu");
  if (!headerMenu) return;

  const items = headerMenu.querySelectorAll("details");
  for (const item of items) {
    let closeTimer;

    item.addEventListener("mouseover", () => {
      clearTimeout(closeTimer);
      item.setAttribute("open", true);
    });

    // Add 250ms delay before closing so the user has time
    // to move the cursor from the nav item down to the panel
    item.addEventListener("mouseleave", () => {
      closeTimer = setTimeout(() => {
        item.removeAttribute("open");
      }, 250);
    });
  }
})();
